export enum CompanyRole {
  COMPANY_ADMIN = 'Administrador de empresa',
  USER = 'Usuario',
  TOMADOR_INVENTARIO = 'Tomador de Inventario',
}
